import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { LoginPageRole, RolePath } from '../component/UserPermission';
import { CartUtils } from '../utils/javascriptUtils';

var _ = require('lodash');
export const count = {
  // initial state
  state: 0,
  reducers: {
    // handle state changes with pure functions
    increment(state, payload) {
      return state + payload
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    async incrementAsync(payload, rootState) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      dispatch.count.increment(payload)
    }
  })
};

export const app = {
    state: {
      isLoading: true,
      login: false 
    },
    reducers: {
      signin(email, full_name) {
        return {
          isLoading: false,
          login: true
        };
      },
      signout(state) {
        return {
          ...state,
          isLoading: false,
          login: false
        };
      }
    },
    effects: (dispatch) => ({
      checkTokenAsync() {
        axios({
          method: 'get',
          url: window.api_url + '/admin/api/auth/user/info',
          withCredentials: true
        }).then(function (response) {
          if(localStorage.getItem("auth_token") && response.data.data && LoginPageRole.isAllowLogin(response.data.data.role)) {
            dispatch.app.signin(response.data.data.email,response.data.data.full_name);
          }else {
            dispatch.app.signout();
          }
        }).catch(function (error) {
          if (error.response && error.response.status === 403) {
            dispatch.app.signout();
          } else {
            console.log(error);
          }
        });
      },
      async signoutAsync() {
        await axios({
          method: 'post',
          url: window.api_url + '/admin/api/auth/logout',
          withCredentials: true
        });
        dispatch.app.signout();
        localStorage.setItem("auth_token", null);
        window.location.href = "/";
      },
      async getUserToken() {
        await axios({
          method: 'get',
          url: window.api_url + "/admin/api/auth/token",
          withCredentials: true
        }).then(function (response) {
          window.userToken = response.data.data;
        })
      }
    })
}

export const userProfile = {
  state: {
    data: null,
    role_path: null
  },
  reducers: {
    setUserProfile(state, data) {
      return {
        ...state,
        data: data
      };
    },
    setRolePath(state, role_path) {
      return {
        ...state,
        role_path: role_path
      };
    },
  },
  effects: (dispatch) => ({
    async loadUserAsync() {
      const res = await axios({
        method: 'get',
        url: window.api_url + '/admin/api/auth/user/info',
        withCredentials: true
      });
      dispatch.userProfile.setUserProfile(res.data.data);
      dispatch.userProfile.setRolePath(RolePath(res.data.data.role));
    }
  })
}

export const customerData = {
  state: {
    data: null,
    parent_profile: null,
    sub_profiles: null,
    agency_customer_list: []
  },
  reducers: {
    setCustomer(state, data) {
      return {
        ...state,
        data: data
      };
    },
    setDomainProfile(state, data) {
      return {
        ...state,
        parent_profile: data.parent_profile,
        sub_profiles: data.sub_profiles
      };
    },
    // Dùng để clear data trong store, để tránh cache lại dữ liệu.
    // Dùng trong componentWillUnmount 
    clearDomainProfileValue(state) {
      return {
        ...state,
        parent_profile: null,
        sub_profiles: null
      };
    },
    setAgencyCustomers(state, data) {
      return {
        ...state,
        agency_customer_list: data
      }
    }
  },
  effects: (dispatch) => ({
    async loadAgencyCustomers(agency_id) {
      const res = await axios({
        method: 'get',
        url: window.api_url + '/admin/api/agency/customer-list/' + agency_id,
        withCredentials: true
      });
      dispatch.customerData.setAgencyCustomers(res.data.data);
    },
    async loadCustomerAsync(customer_id) {
      const res = await axios({
        method: 'get',
        url: window.api_url + '/admin/api/customer/' + customer_id,
        withCredentials: true
      });
     
      dispatch.customerData.setCustomer(res.data.data);
      if(res.data.data && res.data.data.role == "AGENCY") {
        dispatch.customerData.loadAgencyCustomers(res.data.data.agency_id)
      }
    },
    async loadDomainProfileAsync(domain_profile_id) {
      const res = await axios({
        method: 'get',
        url: window.api_url + '/api/user/domain/profile/detail/' + domain_profile_id,
        withCredentials: true
      });
      dispatch.customerData.setDomainProfile(res.data.data);
    }
    
  })
}

export const messageModify = {
  state: {
    ticket_data: [],
    invoice_setup_data: [],
  },
  reducers: {
    setTicketData(state, data) {
      return {
        ...state,
        ticket_data: data
      }
    },
    setInvoiceSetupList(state, data) {
      return {
        ...state,
        invoice_setup_data: data
      }
    }
  },
  effects: (dispatch) => ({
    // Tải và cập nhật số lượng yêu cầu hỗ trợ mới phản hồi từ kỹ thuật.
    async ticketModifyReload() {
      axios({
        method: 'get',
        url: window.api_url + "/admin/api/ticket/new-response/list",
        withCredentials: true
      }).then(function (response) {
        dispatch.messageModify.setTicketData(response.data.data);
      });
    },
    // Tải và cập nhật số đơn hàng cần khởi tạo.
    async invoiceSetupReload() {
      axios({
        method: 'get',
        url: window.api_url + "/admin/api/invoice/item/setup/list",
        withCredentials: true
      }).then(function (response) {
        dispatch.messageModify.setInvoiceSetupList(response.data.data);
      });
    }
  })
}

export const product = {
  state: {
    data: null,
  },
  reducers: {
    setProductData(state, data) {
      return {
        ...state,
        data: data
      }
    },
    clearProductDataValue() {
      return {
        data: null
      }
    }
  },
  effects: (dispatch) => ({
    // Lấy lên product theo mã ID.
    async loadProductAsync(product_id) {
      axios({
        method: 'get',
        url: window.api_url + "/admin/api/product/" + product_id,
        withCredentials: true
      }).then(function (response) {
        dispatch.product.setProductData(response.data.data);
      });
    }
  })
}

export const dcServer = {
  state: {
    data: null,
  },
  reducers: {
    setDcServerData(state, data) {
      return {
        ...state,
        data: data
      }
    },
    clearDcServerDataValue() {
      return {
        data: null
      }
    }
  },
  effects: (dispatch) => ({
    // Lấy Dc Server theo mã ID.
    async loadDcServerAsync(dc_server_id) {
      axios({
        method: 'get',
        url: window.api_url + "/admin/api/dc_server/" + dc_server_id,
        withCredentials: true
      }).then(function (response) {
        dispatch.dcServer.setDcServerData(response.data.data);
      });
    }
  })
}
